import angular from 'angular';
import procedureDetailComponent from './procedure-detail.component';
import ProcedureDetailService from './procedure-detail.service';
import procedureDetailConfig from './procedure-detail.config';

import FeaturedSliderModule from '../../home/featured-slider/featured-slider';

let procedureDetailModule = angular.module('procedureDetail',[FeaturedSliderModule.name])
  .component('procedureDetail', procedureDetailComponent)
  .service('ProcedureDetailService', ProcedureDetailService)
  .config(procedureDetailConfig);

export default procedureDetailModule;



// WEBPACK FOOTER //
// ./www/components/catalog/procedure-detail/procedure-detail.js